module.exports = __webpack_public_path__ + "static/video-1d4a542cbc025cdd38769014981ecd07.mp4";